<div class="table-responsive" *ngIf="treeData && showCustomTable && !loadingTable" id="nodeTypeTableContainer">
  <table class="table table-sm border border-top-0" id="myTableElementId" *ngIf="isValidTable && isValidHeader">
    <caption class="sr-only">Nodes table</caption>
    <thead>
      <tr>
        <ng-container *ngFor="let key of Object.keys(nodeTypeData);let header1 = index;">
          <!-- height of the th to be cal and added to the th -->
          <th scope="col" class="p-0 text-wrapped header" [style.height]="headerHeight" [hidden]="!nodeTypeData[key][0].display"
            [style.width]="nodeTypeData[key][0].width+'px'" [attr.colspan]="nodeTypeData[key][0].metadataList?.length">
            <p class="mb-0" id="{{header1}}_{{nodeTypeData[key][0].key}}">{{nodeTypeData[key][0].key}}</p>
          </th>
        </ng-container>
      </tr>

      <tr class="">
        <!-- line 8 th height to be used as top: {{height}} -->
        <th scope="col" *ngFor=" let key of Object.keys(columns);let header2=index;" class="p-0 header__sub">
          <p class="mb-0" id="{{header2}}_{{ key.split('#||#')[1] }}">{{ key.split('#||#')[1] }}</p>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of virtualRenderItems" class="border">
        <ng-container *ngFor="let key of Object.keys(row);let i = index">
          <ng-container *ngIf="key !== 'item_id' && key !== 'level'">
            <td [attr.rowspan]="row[key].split('#||#')[1]">
              <button *ngIf="row[key].split('#||#')[0]!==''" id="{{row[key].split('#||#')[3]}}-{{'node'}}-{{i}}"
                class="text-left p-1 w-100 btn"
                (click)="openDetails(row[key].split('#||#')[3]? row[key].split('#||#')[3]:null, key.split('_')[1], false);setFocusCellItem(row[key].split('#||#')[3],i);"
                [ngClass]="{'btn-secondary': clicked === row[key].split('#||#')[3], 'btn-clear': clicked !== row[key].split('#||#')[3]}">
                <span [mathJax]="row[key].split('#||#')[0]"></span>
              </button>
            </td>
          </ng-container>
        </ng-container>
      </tr>


    </tbody>
  </table>

  <p *ngIf="!isValidTable || !isValidHeader">Not compatible for Table View.</p>
</div>

<app-preloader *ngIf="!treeData || loadingTable" [loaderText]="'Loading Table..'"
  class="w-100 position-fixed preloader-backdrop"></app-preloader>
<app-tabular-tree-side-pane #tabularTreeSidePaneComponent [taxonomyData]="treeData" [showNavigation]="showNavigation"
  (sidePanelClosed)="updateFocus($event);">
</app-tabular-tree-side-pane>
